import type { Category } from '../lib/api';
import { categoryLabel } from '../lib/categories';
import styles from './Badges.module.css';
import { Icon } from './Icon';

export function VerifiedBadge({ label = 'Verified local' }: { label?: string }) {
  return (
    <span className={styles.verified}>
      <Icon name="check" size={13} />
      {label}
    </span>
  );
}

export function CategoryTag({ category, className }: { category: Category; className?: string }) {
  return (
    <span className={[styles.tag, styles[category], className].filter(Boolean).join(' ')}>
      {categoryLabel(category)}
    </span>
  );
}
